import { render } from "./TECMQuestionQuizSimuladoLanding.vue?vue&type=template&id=5151462a&translate=no"
import script from "./TECMQuestionQuizSimuladoLanding.vue?vue&type=script&lang=js"
export * from "./TECMQuestionQuizSimuladoLanding.vue?vue&type=script&lang=js"

import "./TECMQuestionQuizSimuladoLanding.vue?vue&type=style&index=0&id=5151462a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__